const refFiscalMonths = ['Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'];
const refFiscalSubtractfor = [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0];

export default (currentMonth, currentYear) => {
    let pivotIndex = refFiscalMonths.indexOf(currentMonth)
    let fiscalYear = parseInt(currentYear) + parseInt(refFiscalSubtractfor[pivotIndex])
    return fiscalYear;
}
